module.exports = __webpack_public_path__ + "img/logo-icon.f216c5bc.png";